import {
  IBooleanCondition,
  IDateCondition,
  IMultiSelectCondition,
  INumberCondition,
  ISingleSelectCondition,
  IStringCondition
} from '.'

export type ConditionTypesUnion =
  | IBooleanCondition
  | IDateCondition
  | IMultiSelectCondition
  | INumberCondition
  | ISingleSelectCondition
  | IStringCondition

export enum ConditionTypeEnum {
  Boolean = 'Boolean',
  Date = 'Date',
  MultiSelect = 'MultiSelect',
  Number = 'Number',
  SingleSelect = 'SingleSelect',
  String = 'String'
}
